const removePhoneFormatting = (formattedPhoneNumber: string) => formattedPhoneNumber.replace(/[- ()]/g, '');

export { removePhoneFormatting };
export * from './get-portal-type';
export * from './embedded';
